// Static content data for BRHC landing page

export const COMPANY = {
  name: "Royal Homes & Consults ltd",
  short: "BRHC",
  full: "Royal Homes & Consults ltd",
  tagline: "Living As You Are Pleased",
  phone: "07085145410",
  website: "www.barkaroyalhomes.com",
  email: "hello@barkaroyalhomes.com",
  enquiryEmail: "francisbarka1@gmail.com",
  hours: [
    { day: "Mon – Fri", time: "8:00 AM – 6:00 PM" },
    { day: "Saturday", time: "9:00 AM – 2:00 PM" },
    { day: "Sunday", time: "Closed" },
  ],
};

export const STATS = [
  { value: "50+", label: "Projects Completed" },
  { value: "100%", label: "Client Satisfaction" },
  { value: "10+", label: "Years of Experience" },
  { value: "5", label: "Nigerian States" },
];

export const CORE_VALUES = [
  {
    title: "Integrity",
    text: "Honesty and transparency in every contract, drawing and handshake.",
  },
  {
    title: "Quality & Excellence",
    text: "Uncompromising standards from foundation to finishing.",
  },
  {
    title: "Innovation",
    text: "Modern methods, materials and design thinking for Nigerian living.",
  },
  {
    title: "Safety & Compliance",
    text: "Adherence to engineering codes and rigorous safety on every site.",
  },
  {
    title: "Client-Centered",
    text: "Bespoke solutions shaped around your goals, lifestyle and budget.",
  },
  {
    title: "Sustainability",
    text: "Climate-responsive design and responsible sourcing of materials.",
  },
];

export const SERVICES = [
  {
    number: "01",
    title: "Construction Solutions",
    icon: "HardHat",
    description:
      "Integrated construction delivery for residential, commercial, institutional, and mixed-use developments executed with technical precision and structural integrity.",
    items: [
      "Residential building construction",
      "Commercial and institutional developments",
      "Mixed-use developments",
      "Renovation, remodeling, and structural upgrades",
    ],
  },
  {
    number: "02",
    title: "Real Estate Development & Management",
    icon: "Building2",
    description:
      "End-to-end property solutions across development, acquisition, leasing, and management of landed and built assets.",
    items: [
      "Property development (landed and built assets)",
      "Sales and acquisition of land and buildings",
      "Leasing and rental services (residential and commercial)",
      "Property and facility management",
    ],
  },
  {
    number: "03",
    title: "Professional Consultancy Services",
    icon: "ClipboardList",
    description:
      "Professional advisory services that strengthen planning, decision-making, supervision, and long-term investment outcomes.",
    items: [
      "Construction consultancy and technical advisory",
      "Project planning, supervision, and management",
      "Property valuation",
      "Feasibility studies",
      "Real estate investment and development advisory",
    ],
  },
];

export const PROJECTS = [
  {
    id: "self-contained-girei",
    title: "1-Bedroom Self-Contained Residence",
    location: "Sengere Futy, Girei",
    category: "Residential",
    status: "Completed",
    year: "2023",
    image:
      "https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&w=1200&q=80",
    summary:
      "A compact yet generous self-contained unit behind Pagubsa Ventures — designed for comfort, light, and ease of upkeep.",
    features: [
      "Spacious living area with cross-ventilation",
      "Modern kitchen with built-in cabinetry",
      "Built-in wardrobe and ensuite layout",
    ],
  },
  {
    id: "semi-detached-fumbina",
    title: "Semi-Detached 1-Bedroom Bungalow",
    location: "Fumbina, Girei, Adamawa State",
    category: "Residential",
    status: "Completed",
    year: "2023",
    image:
      "https://images.pexels.com/photos/31737860/pexels-photo-31737860.jpeg",
    summary:
      "A quiet, modern bungalow behind Fumbina FM — clean lines, quality materials and a tasteful ensuite footprint.",
    features: [
      "Modern semi-detached architecture",
      "Quality materials, durable finishes",
      "Ensuite bathroom & private entry",
    ],
  },
  {
    id: "four-unit-jimeta",
    title: "Four-Unit Residential Apartments",
    location: "Lakare, Behind Zone 3, Jimeta",
    category: "Residential",
    status: "Completed",
    year: "2024",
    image:
      "https://images.unsplash.com/photo-1670589953882-b94c9cb380f5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjByZXNpZGVudGlhbCUyMGJ1aWxkaW5nJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzc5NTgyMjQ1fDA&ixlib=rb-4.1.0&q=85",
    summary:
      "Four contemporary apartments delivered as a calm, contemporary residential block with shared landscaped surrounds.",
    features: [
      "Contemporary residential living",
      "Functional, daylight-led floor plans",
      "Shared landscaped surrounds",
    ],
  },
  {
    id: "multipurpose-abuja",
    title: "Multi-Purpose Hall & 12-Suite Motel Complex",
    location: "Ralph Shodeinde Street, CBD Abuja",
    category: "Commercial",
    status: "Design Phase",
    year: "2025",
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&q=80",
    summary:
      "A landmark mixed-use design for the National Commission for College of Education — pairing a 400-capacity auditorium with a 12-suite motel.",
    features: [
      "400-capacity auditorium",
      "12-suite roadside motel",
      "State-of-the-art services & acoustics",
    ],
  },
  {
    id: "bungalow-jos",
    title: "Modern 3-Bedroom Bungalow",
    location: "Diye, Jos, Plateau State",
    category: "Residential",
    status: "Design Phase",
    year: "2025",
    image:
      "https://images.pexels.com/photos/13807472/pexels-photo-13807472.jpeg",
    summary:
      "A climate-responsive Jos residence — thermal mass, deep eaves and sustainable timber accents tuned to highland weather.",
    features: [
      "Climate-responsive massing",
      "Thermal insulation & passive cooling",
      "Sustainable, locally-sourced materials",
    ],
  },
  {
    id: "bungalow-akwa-ibom",
    title: "Modern 3-Bedroom Bungalow",
    location: "Ndon Edikpoi, Akwa Ibom",
    category: "Residential",
    status: "Design Phase",
    year: "2025",
    image:
      "https://images.pexels.com/photos/14526255/pexels-photo-14526255.jpeg",
    summary:
      "A bright family bungalow with deep verandahs, large openings and a spacious open-plan core for southern Nigerian living.",
    features: [
      "Modern tropical architecture",
      "Generous natural lighting",
      "Open, spacious internal layout",
    ],
  },
];

export const WHY_CHOOSE = [
  {
    icon: "Award",
    title: "Professional Excellence",
    text: "A team of registered engineers, architects and consultants committed to superior outcomes.",
  },
  {
    icon: "Clock",
    title: "Timely Delivery",
    text: "Disciplined programming and proven track record of meeting client deadlines.",
  },
  {
    icon: "Leaf",
    title: "Sustainable Development",
    text: "Environmentally responsible construction practices and material sourcing.",
  },
  {
    icon: "ShieldCheck",
    title: "Structural Integrity",
    text: "The highest standards of engineering safety, durability and code compliance.",
  },
  {
    icon: "Sparkles",
    title: "Innovative Design",
    text: "Architecture that balances aesthetic ambition with functional, livable spaces.",
  },
  {
    icon: "Heart",
    title: "Client Satisfaction",
    text: "Personalised solutions shaped around your goals, lifestyle and budget.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Aisha Mohammed",
    role: "Homeowner, Jimeta",
    initials: "AM",
    rating: 5,
    quote:
      "BRHC delivered our family home on time and under budget. The attention to finishing details is exactly what we hoped for.",
  },
  {
    name: "Ibrahim Sani",
    role: "Investor & Landlord",
    initials: "IS",
    rating: 5,
    quote:
      "Their advisory team helped me pick the right plot and the right scheme. Two years later, the rental yields speak for themselves.",
  },
  {
    name: "Chinedu Okafor",
    role: "Commercial Client",
    initials: "CO",
    rating: 5,
    quote:
      "Professional from first meeting to handover. The team understood the brief, respected the budget and built something we are proud of.",
  },
];

// WhatsApp + Calendly
export const WHATSAPP = {
  number: "2347085145410", // intl format without + or spaces
  message:
    "Hello BRHC, I'd like to enquire about your real estate / construction services.",
};

export const SOCIAL_LINKS = [
  {
    platform: "Facebook",
    href: "https://www.facebook.com/share/17wkuPnUkM/",
  },
];

export const CALENDLY_URL = "https://calendly.com/your-brhc-link/consultation";

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Projects", href: "#projects" },
  { label: "Why Us", href: "#why" },
  { label: "Contact", href: "#contact" },
];
